"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { CircleDollarSign, Clock, Wrench } from "lucide-react";
const promises = [{
  title: "Vetted Platforms",
  description: "Access a hand-selected network of premier financing institutions, ensuring security and institutional-grade reliability for every project.",
  icon: CircleDollarSign
}, {
  title: "Speed of Connection",
  description: "Our streamlined infrastructure eliminates traditional friction, facilitating rapid links between projects and capital sources.",
  icon: Clock
}, {
  title: "Expert Guidance",
  description: "Benefit from our deep industry insight and technical bridge that simplifies the complex landscape of project-based financing.",
  icon: Wrench
}];
export default function OurProfessionalPromise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="155412" id="why-choose-lana-connect" className="bg-background py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-6">
            Why Choose Lana Connect
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            We serve as the strategic link between project vision and financial realization, providing a neutral, expert-led path to funding solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {promises.map((promise, i) => <div key={promise.title} data-index={i} className={`transition-all duration-1000 ease-out delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <Card className="h-full bg-card text-card-foreground border-border transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_40px_60px_-15px_rgba(222,47,11,0.1)] hover:border-primary/20 group relative overflow-hidden">
                {}
                <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-primary/5 rounded-full blur-2xl transition-all duration-500 group-hover:bg-primary/10 group-hover:scale-150" />
                
                <CardHeader className="relative z-10 pb-4">
                  <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-accent text-primary transition-transform duration-500 group-hover:scale-110 group-hover:bg-ring/20">
                    <promise.icon className="size-8" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-2xl font-bold tracking-tight text-foreground">
                    {promise.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative z-10">
                  <p className="text-muted-foreground leading-relaxed text-base">
                    {promise.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}